window.addEventListener("load", function () {
    document.querySelectorAll('.popup_getlist .btn_get').forEach(function(btn) {
        
        if (btn.classList.contains('received')) {
            btn.textContent = btn.getAttribute('data-text-success');
        } else {
            btn.textContent = btn.getAttribute('data-text');
        }
        
    });
});